import React, { Fragment } from 'react';
import PieChart from "../pie-chart/pie-chart-component";
import PieChart2 from "../pie-chart-2/pie-chart-component";
import PieChartLegend from "../pie-chart-legend/pie-chart-legend-component";
import PieChartFooter from "../pie-chart-footer/pie-chart-footer-component";
import "./pie-chart-wrapper.css";
import Spinner from "../spinner/spinner-component";



const PieChartWrapper = (
  {
    title,
    data,
    svgId,
    valueName,
    value,
    loading,
    link,
    footer,
    height,
    legendHeight,
    minHeight,
    error,
    linkToWord,
    reportUrl
  }
  ) => {

  return (
    <div className="chart shadow" style={{minHeight}}>
      {
        loading ?
          <Spinner
            absolute
            loading={loading}
            fontSize="18px"
            top="10px"
            left="10px"
          />
          :
          null
      }
      <Fragment>
        {
          error ? <span>{ error }</span> : null
        }
        {
          data.length ?
          <h2 style={{margin: '10px 0', textAlign: 'center'}}>{title}</h2>
          :
          null
        }
        <div style={{display: 'flex'}} ref={node => this.topWordsContainer = node}>
          {
            data.length ?
            <PieChart
              title={title}
              height={height}
              data={data}
              svgId={svgId}
              valueName={valueName}
              value={value}
            />
              :
              null
          }
          {
            data.length ?
              <PieChartLegend
                data={data}
                valueName={valueName}
                value={value}
                height={legendHeight}
                linkToWord={linkToWord}
                reportUrl={reportUrl}
              />
              :
              null
          }

        </div>
        {
          footer && data.length ? <PieChartFooter link={link} /> : null
        }
      </Fragment>
    </div>
  )

};

export default PieChartWrapper;


// WEBPACK FOOTER //
// ./src/components/pie-chart-wrapper/pie-chart-wrapper-component.js